import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './views/Home';
import PetSummary from './views/PetSummary';
import SignIn from './views/SignIn';
import Register from './views/Register';
import { PetSummaryProvider } from './store/PetStore';
import CreateOrganization from './views/CreateOrganization';
import Dashboard from './views/Dashboard';
import Users from './views/Users';
import Organization from './views/Organization';
import Locations from './views/Locations';
import Billing from './views/Billing';
import Catalogs from './views/Catalogs';
import Reports from './views/Reports';
import { CatalogProvider } from './store/CatalogStore';
import PrivacyPolicy from './views/PrivacyPolicy';
import Support from './views/Support';
import DeleteAccount from './views/DeleteAccount';
import DownloadRedirect from './views/DownloadRedirect';

function App() {
  return (
    <CatalogProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/organization" element={<Organization />} />
          <Route path="/organization/create" element={<CreateOrganization />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/users" element={<Users />} />
          <Route path="/catalogs" element={<Catalogs />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/delete" element={<DeleteAccount />} />
          <Route path="/download" element={<DownloadRedirect />} />
          <Route
            path="/summary"
            element={(
              <PetSummaryProvider>
                <PetSummary />
              </PetSummaryProvider>
            )}
          />
        </Routes>
      </Router>
    </CatalogProvider>
  );
}

export default App;
